import {
  suggestedOptionNameDefaults,
  useProposalOptionNameDefaults,
} from '@airship-platform/airship-proposal';
import { Loader } from '@airship-platform/jam-web/components';
import { zodResolver } from '@hookform/resolvers/zod';
import { PropsWithChildren, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions';
import {
  OPTION_TEMPID_PREFIX,
  OptionFormInputs,
  OptionFormSchema,
} from './optionForm.models';

const OptionFormProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { options, isLoading } = useAppointmentProposalOptions();
  const { optionNames } = useProposalOptionNameDefaults();

  const availableNames = useMemo(
    () =>
      !options.length
        ? (optionNames.length
            ? optionNames.map((option) => option.name)
            : suggestedOptionNameDefaults
          ).map((name, idx) => ({
            name,
            templateOptionIds: [],
            optionId: OPTION_TEMPID_PREFIX + idx,
            sortOrder: idx,
          }))
        : options.map((option) => ({
            name: option.name,
            templateOptionIds: [],
            optionId: option.appointmentProposalOptionId,
            sortOrder: option.sortOrder,
          })),
    [optionNames, options]
  );

  const optionForm = useForm<OptionFormInputs>({
    resolver: zodResolver(OptionFormSchema),
    defaultValues: { names: availableNames, optionType: 'MANUAL' },
  });

  return (
    <FormProvider {...optionForm}>
      {children}
      <Loader isLoading={isLoading} />
    </FormProvider>
  );
};

export default OptionFormProvider;
